import { createModule } from '../createModule';

export const position = createModule('position');